import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as parse from 'date-fns/parse';
import * as format from 'date-fns/format';

// Types
import { IStore } from '../../store/Store';

// Components
import Box from '../../components/Box';
import Dialog, { AlertDialog } from '../../components/Dialog';
import Paper from '../../components/Paper';
import SlimCropper, { ISlim } from '../../components/SlimCropper';
import { CircularProgress } from '../../components/Progress';
import Tabs, { Tab } from '../../components/Tabs';
import Typography from '../../components/Typography';

import MeDialogDetails, { IFormValues } from './MeDialogDetails';
import MeDialogPassword from './MeDialogPassword';
import MeDialogSettings from './MeDialogSettings';

// Style
import './MeDialog.css';

// Component
interface IProps {
  store?: IStore;
  state: { open: boolean };
  onClose?: () => void;
  onExited?: () => void;
}

class MeDialog extends React.Component<IProps, {}> {
  @observable tabIndex = 0;

  @observable
  alertDialogState = {
    open: false,
    title: '',
    description: ''
  };

  openDetailsSuccessDialog() {
    this.alertDialogState = {
      open: true,
      title: 'Successfully Updated',
      description: 'Your details is successfully saved.'
    };
  }

  openDetailsErrorDialog() {
    this.alertDialogState = {
      open: true,
      title: 'Something went wrong',
      description: 'Please try again or contact support.'
    };
  }

  openPasswordSuccessDialog() {
    this.alertDialogState = {
      open: true,
      title: 'Successfully Updated',
      description: 'Your password is successfully saved.'
    };
  }

  openPasswordErrorDialog() {
    this.alertDialogState = {
      open: true,
      title: 'Wrong Password',
      description: 'Please try again or contact support.'
    };
  }

  handleCropperConfirm = async (base64: string) => {
    this.props.store!.meStore.meUploadPhoto(base64);
  };

  handleCropperRemove = async () => {
    this.props.store!.meStore.meDeletePhoto();
  };

  handlePasswordSubmit = async (values: {
    oldPassword: string;
    password: string;
  }) => {
    try {
      await this.props.store!.meStore.meChangePassword(values);
      this.openPasswordSuccessDialog();
    } catch (err) {
      this.openPasswordErrorDialog();
    }
  };

  handleTabChange = (e: React.ChangeEvent<{}>, index: number) => {
    this.tabIndex = index;
  };

  handleDetailsSubmit = async (values: IFormValues) => {
    try {
      await this.props.store!.meStore.meEdit(values);
      this.openDetailsSuccessDialog();
    } catch (err) {
      this.openDetailsErrorDialog();
    }
  };

  handleDialogClose = () => {
    this.alertDialogState = {
      open: false,
      title: '',
      description: ''
    };
  };

  render() {
    const handleCropperConfirm = this.handleCropperConfirm;
    const handleCropperRemove = this.handleCropperRemove;
    const meStore = this.props.store!.meStore;
    if (meStore.user === null) {
      return (
        <Box mt={5} align="center">
          <CircularProgress />
        </Box>
      );
    }
    return (
      <Dialog
        open={this.props.state.open}
        onClose={this.props.onClose}
        classes={{ paper: 'App_MeDialog_Paper' }}
      >
        <Paper>
          <div
            style={{
              background: 'linear-gradient(45deg, #FF4A5D 0%, #FF9244 100%)',
              color: '#fff'
            }}
          >
            <div
              style={{ paddingTop: 48, paddingBottom: 16, textAlign: 'center' }}
            >
              <SlimCropper
                style={{
                  height: 164,
                  width: 164,
                  margin: 'auto auto',
                  boxShadow:
                    '0px 3px 5px -1px rgba(0, 0, 0, 0.2),' +
                    '0px 5px 8px 0px rgba(0, 0, 0, 0.14),' +
                    '0px 1px 14px 0px rgba(0, 0, 0, 0.12)'
                }}
                ratio="1:1"
                minSize={{ width: 250, height: 250 }}
                forceSize={{ width: 256, height: 256 }}
                forceType="jpg"
                instantEdit={true}
                didConfirm={function(this: ISlim) {
                  handleCropperConfirm(this.dataBase64.output.image);
                }}
                didRemove={function(this: ISlim) {
                  handleCropperRemove();
                }}
                uploadBase64={true}
                initialImage={meStore.user.photoUrl}
                edit={false}
              />
              <br />
              <br />
              <Typography type="headline" color="inherit">
                {`${meStore.user.firstName} ${meStore.user.lastName}`}
              </Typography>
              <Typography
                type="subheading"
                color="inherit"
                style={{ opacity: 0.6 }}
              >
                Member since{' '}
                {format(parse(meStore.user.created), 'DD. MMMM YYYY')}
              </Typography>
            </div>
            <Tabs
              value={this.tabIndex}
              onChange={this.handleTabChange}
              centered={true}
            >
              <Tab label="Details" />
              <Tab label="Password" />
              <Tab label="Settings" />
            </Tabs>
          </div>
          <div style={{ minHeight: 260 }}>
            {this.tabIndex === 0 ? (
              <MeDialogDetails
                user={meStore.user}
                onSubmit={this.handleDetailsSubmit}
              />
            ) : null}
            {this.tabIndex === 1 ? (
              <MeDialogPassword onSubmit={this.handlePasswordSubmit} />
            ) : null}
            {this.tabIndex === 2 ? <MeDialogSettings /> : null}
          </div>
        </Paper>
        <AlertDialog
          state={this.alertDialogState}
          onClose={this.handleDialogClose}
          onConfirm={this.handleDialogClose}
        />
      </Dialog>
    );
  }
}

export default inject('store')(observer(MeDialog));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/MeDialog.tsx